import PropTypes from "prop-types";
import React from "react";
import ImageWithInitials from "../../../Utils/ImageWithInitials";

// Match PostEditor EntryComponent structure exactly
const EntryComponent = ({
  mention,
  theme = {}, // Optional theme for compatibility
  searchValue, // eslint-disable-line no-unused-vars
  isFocused, // eslint-disable-line no-unused-vars
  ...parentProps
}) => {
  // Use theme classes if provided, otherwise use default classes
  const containerClass = theme.mentionSuggestionsEntryContainer || "simple-post-editor__entry";
  const rightClass = theme.mentionSuggestionsEntryContainerRight || "simple-post-editor__entry-right";
  const textClass = theme.mentionSuggestionsEntryText || "simple-post-editor__entry-text";

  return (
    <div {...parentProps}>
      <div className={containerClass}>
        <div
          data-role-id={`${mention.OwnerUserName}`}
          className={rightClass}
        >
          <div className="d-flex align-items-center">
            {mention?.OwnerShowInitals === true ? (
              <ImageWithInitials
                initials={mention?.OwnerInitials}
                width={25}
                background={"purple"}
              />
            ) : mention?.OwnerLogo == null ? (
              <img 
                src="/images/settings-v2/highground-dp.svg" 
                alt=""
                className="mention-logo"
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <img
                src={mention?.OwnerLogo}
                alt=""
                className="mention-logo"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "/images/settings-v2/highground-dp.svg";
                }}
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  objectFit: "contain",
                }}
              />
            )}
            <div className={`${textClass} simple-post-editor__entry-text`}>
              {mention.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EntryComponent.propTypes = {
  mention: PropTypes.shape({
    name: PropTypes.string.isRequired,
    OwnerUserName: PropTypes.string,
    OwnerLogo: PropTypes.string,
    OwnerShowInitals: PropTypes.bool,
    OwnerInitials: PropTypes.string,
  }).isRequired,
  theme: PropTypes.shape({
    mentionSuggestionsEntryContainer: PropTypes.string,
    mentionSuggestionsEntryContainerRight: PropTypes.string,
    mentionSuggestionsEntryText: PropTypes.string,
  }),
  searchValue: PropTypes.string,
  isFocused: PropTypes.bool,
};

export default EntryComponent;
